import dayjs from "dayjs";

interface SeasonLike {
    startDate: string | Date;
    endDate?: string | Date | null;
}

/**
 * Returns true if a season is currently active:
 * - No end date and start date is in the past (ongoing indefinitely), OR
 * - Start date is in the past and end date is in the future (in progress).
 *
 * Future seasons (start date not yet reached) are considered inactive.
 */
export const isSeasonActive = (season: SeasonLike, now: dayjs.Dayjs = dayjs()): boolean => {
    const started = dayjs(season.startDate).isBefore(now);

    if (!season.endDate) {
        return started;
    }

    return started && dayjs(season.endDate).isAfter(now);
};

/**
 * Returns true if a ministry has at least one currently active season.
 * Safe to use directly as a `.filter()` callback.
 */
export const hasActiveSeasons = (ministry: { seasons: SeasonLike[] }): boolean => {
    const now = dayjs();
    return ministry.seasons.some((season) => isSeasonActive(season, now));
};
